import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { Position } from "../../models/position"
import { FeatureService } from "../../services/FeatureService"
import { useStoreRechnung } from "../../store"
import { eventhandlingForLists } from "../hooks/EventhandlingForLists"
import { PositionView } from "./PositionView"

export interface PositionenViewProps {
    positionen?: Position[]
    path: string
    name: string
    nummerPrefix?: string
    umsatzsteuerFixedValue?: number
    umsatzsteuerFixedCode?: string
    subPostion?: boolean
}

export function PositionListView({ positionen, name, path, umsatzsteuerFixedValue, umsatzsteuerFixedCode, subPostion }: PositionenViewProps) {
    const { t } = useTranslation()
    const { positionen: storepos } = useStoreRechnung("positionen")

    // get pos from store if not supplied
    const positionenIntern = positionen ? positionen : storepos

    const disabled = FeatureService.isFeatureActive("DEMO") && positionenIntern.length >= 1

    const { onChange, remove, add } = useMemo(() => {
        const newPosition = () => {
            const newPosition = new Position()
            newPosition.positionsnummer = (positionenIntern.length + 1).toString()
            return newPosition
        }
        return eventhandlingForLists(path, newPosition)
    }, [path, positionenIntern.length])

    return (
        <Components.Collapsible title={name} collapsed={false} data-index={path}>
            {positionenIntern.map((p, idx) => (
                <PositionView
                    key={idx}
                    index={idx}
                    position={p}
                    path={path + "." + idx}
                    umsatzsteuerFixedCode={umsatzsteuerFixedCode}
                    umsatzsteuerFixedValue={umsatzsteuerFixedValue}
                    onChangeFactory={onChange}
                    onRemoveFactory={remove}
                />
            ))}

            <Components.Row>
                <Components.Col align={Components.Align.RIGHT}>
                    <Components.Button
                        style={Components.ButtonStyle.SECONDARY}
                        label={subPostion ? t("rechnung.positionen.neueUnterPosition") : t("rechnung.positionen.neuePosition")}
                        onClick={add}
                        disabled={disabled}
                        id={"newPositionBtn"}
                        tooltip={disabled ? t("demoversion.nicht.aktiv.postionAdd") : ""}
                        tooltipAtDisabled={disabled}
                    />
                </Components.Col>
            </Components.Row>
        </Components.Collapsible>
    )
}
